import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Join class names, letting a later Tailwind utility beat an earlier one in the
 * same group.
 *
 * `clsx` alone produces `"px-2 px-4"` and the browser applies whichever the
 * stylesheet happens to order last — so a component's `className` prop cannot
 * reliably override its own default. `twMerge` resolves the conflict by group,
 * which is what makes `<Button className="px-4" />` actually work.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
